module.exports = __webpack_public_path__ + "assets/8b50a5e834dbfdb0a6827364438aacca.mp3";